<form [formGroup]="dosatorProductFormGroup">
  <div class="flex--column">
    <h3>Dosator setting {{ index + 1 }}</h3>
  </div>

  <div class="flex--column spacing--padding-right">
    <mat-form-field class="flex__child--auto">
      <mat-select
        [hideSingleSelectionIndicator]="true"
        panelClass="mat-select-product-panel"
        placeholder="{{ 'settings.dosator-setting.product.label.product' | translate }}"
        formControlName="productId"
        data-test="dosator-setting__productId"
      >
        <mat-option *ngFor="let product of products" [value]="product.id">
          {{ product.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <app-dosator-setting-product-item-table
    [formGroup]="conversionFormGroup"
    [conversions]="dosatorProduct.conversions"
  >
  </app-dosator-setting-product-item-table>

  <div class="flex--column spacing--margin-bottom deletebutton spacing--margin-top">
    <button
      *ngIf="canDelete"
      mat-flat-button
      color="primary"
      color="warn"
      (click)="delete()"
      data-test="create-dosator-setting__delete-pen"
    >
      <mat-icon>delete</mat-icon>{{ 'settings.dosator-setting.delete-product' | translate }}
    </button>
  </div>
</form>
